import { createFileRoute } from "@tanstack/react-router";
import AddictionTreatmentGlassboroNJ from "@/pages/AddictionTreatmentGlassboroNJ";
import { routeHead } from "@/lib/route-head";

export const Route = createFileRoute("/addiction-treatment-glassboro-nj")({
  head: () => routeHead("/addiction-treatment-glassboro-nj"),
  component: AddictionTreatmentGlassboroNJ,
});
